import { Discount } from '../../types/discounts';
import { DiscountType, LoyaltyType, LoyaltyDiscountType, GroupItems } from '../types';
import { DropdownOption } from '../common/components/MarketingDropdown';

interface Helpers {
    days: DropdownOption[];
    months: DropdownOption[];
    itemsBought: DropdownOption[];
}

export const parseDiscount = (discount: Discount, helpers: Helpers) => {
    let discountType: DiscountType | undefined;
    let loyaltyType: LoyaltyType | undefined;
    let loyaltyDiscountType: LoyaltyDiscountType | undefined;

    if (discount.reward.type === 'discount_amount') discountType = DiscountType.discountInAmount;
    if (discount.reward.type === 'discount_percent') discountType = DiscountType.discountInPercentage;
    if (discount.reward.type === 'discount_item_quantity') discountType = DiscountType.amountBuyDiscount;
    if (!discount.requirement.stamp && discount.reward.type === 'discount_item_new_price') {
        discountType = DiscountType.fixedPriceDiscount;
    }
    if (discount.requirement.stamp) discountType = DiscountType.loyalty;
    if (discount.requirement.stamp && !discount.requirement?.gross_amount) loyaltyType = LoyaltyType.productsBought;
    if (discount.requirement.stamp && discount.requirement?.gross_amount) loyaltyType = LoyaltyType.visitAndSpending;
    if (discount.reward.type === 'discount_item_percent' && discount.reward.value !== 100) {
        loyaltyDiscountType = LoyaltyDiscountType.inPercentage;
    }
    if (discount.requirement.stamp && discount.reward.type === 'discount_item_new_price') {
        loyaltyDiscountType = LoyaltyDiscountType.inCurrency;
    }
    if (discount.reward.type === 'discount_item_percent' && discount.reward.value === 100) {
        loyaltyDiscountType = LoyaltyDiscountType.freeItem;
    }

    const discountUsageAmount = discount.limitation?.discount_repeat_usage
        ? discount.limitation?.discount_repeat_usage.toString()
        : '';
    const blacklistedItems = discount.limitation?.blacklist ?? [];
    const validFor = discount.limitation?.stamp_expire_days
        ? (discount.limitation?.stamp_expire_days / 30).toString()
        : helpers.months[0].value;
    const discountHours = discount.limitation?.discount_hours;

    const rawItems = discount.requirement.item?.items ?? [];
    let discountValue = '';
    let payFor = '';
    let visitsNumber = '';
    let minimumPurchase = '';
    let itemsBought = '';
    let totalPurchase = '';
    if (
        discountType === DiscountType.discountInAmount ||
        discountType === DiscountType.fixedPriceDiscount ||
        loyaltyDiscountType === LoyaltyDiscountType.inCurrency
    ) {
        discountValue = (discount.reward.value / 100).toString();
    }
    if (
        discountType === DiscountType.discountInPercentage ||
        loyaltyDiscountType === LoyaltyDiscountType.freeItem ||
        loyaltyDiscountType === LoyaltyDiscountType.inPercentage
    ) {
        discountValue = discount.reward.value.toString();
    }
    if (discountType === DiscountType.amountBuyDiscount) {
        const value = discount.requirement.item?.quantity ?? 0;
        payFor = (value - discount.reward.value).toString();
        discountValue = value.toString();
    }
    if (loyaltyType === LoyaltyType.visitAndSpending) {
        visitsNumber = discount.requirement.stamp?.toString() ?? '';
        minimumPurchase = ((discount.requirement.gross_amount ?? 0) / 100).toString() ?? '';
    }
    if (loyaltyType === LoyaltyType.productsBought) {
        itemsBought = discount.requirement.stamp?.toString() ?? helpers.itemsBought[0].value;
    }
    if (discountType === DiscountType.discountInAmount) {
        totalPurchase = discount.requirement.gross_amount?.toString() ?? '';
    }

    const requirements =
        discountHours?.hours.map((hour) => {
            const timeFrom = new Date();
            timeFrom.setHours(Number(hour.start.slice(0, 2)), Number(hour.start.slice(3, 5)));
            const timeTo = new Date();
            timeTo.setHours(Number(hour.end.slice(0, 2)), Number(hour.end.slice(3, 5)));
            return {
                timeFrom,
                timeTo,
                day: hour.day,
            };
        }) ?? [];

    const items = rawItems.map((item) => ({
        name: '',
        id: item.id,
        groupId: item.group_id,
        isBlacklisted: blacklistedItems.includes({
            id: item.id,
            group_id: item.group_id,
        }),
    }));

    return {
        id: discount.id,
        type: discountType,
        loyaltyType,
        loyaltyDiscountType,
        discountValue,
        discountUsageAmount,
        discountCombination: discount.limitation?.discount_combination,
        totalPurchase,
        payFor,
        items: items,
        groupItems: items.length === 0 ? GroupItems.allItems : GroupItems.itemsGrouped,
        title: discount.name,
        description: discount.description,
        visitsNumber,
        minimumPurchase,
        requirements,
        itemsBought,
        validFor,
        emailSendout: false,
        metadata_dintero_exclude_public_description: (discount?.metadata || {} as any)['dintero:exclude:public:description'] as string | undefined,
        webshop: (discount?.links?.find(l => l.rel === 'webshop')?.href || undefined),
    };
};
